/* istanbul ignore file */

import React from 'react'

const AccountPageCarts = () => <div></div>

export default AccountPageCarts
